import React from 'react';

export default function HelpTutorialPage() {

    return (
        <div className={'container mt-4'}>
            <div className={'row'}>
                <div className={'col-lg'}>
                    <p className='mb-3'>Here is a short demo on how to use the tool to submit your translations.</p>
                    <video width="600" height="337" controls>
                        <source src={process.env.PUBLIC_URL + '/translators_tutorial.mp4'} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    )
}
